<template>
  <v-dialog
      v-model="dialog"
      width="600"
      large
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-if="item == null"
          v-bind="attrs"
          v-on="on"
      >
        mdi-plus-box
      </v-icon>
      <v-icon
          v-else
          small
          v-bind="attrs"
          v-on="on"
      >
        mdi-delete-circle
      </v-icon>
    </template>
    <v-card>
      <v-card-title>
        {{ item.dt }}:
        {{ item.public_holiday }}
      </v-card-title>
      <v-card-text>
        Delete this holiday?
        Are you sure?
      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            @click="onSave"
        >
          Delete
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'PublicHolidayDeleteDialog',
  props: {
    item: {default: null},
    length: {default: null},
    disabled: {default: false}
  },

  computed: {
    ...mapGetters('CalendarDate', ['getColumns',]),
    ...mapFields('CalendarDate', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('CalendarDate', {itemListHuman: 'itemList'},),

  },

  methods: {
    ...mapActions('CalendarDate', ['fetchSaveItemField', 'fetchItemList']),


    onSave() {
      console.log('onSave', this.localItem)
      let fields_dict = {}
      fields_dict['id'] = this.localItem.id
      fields_dict['dt'] = this.localItem.dt
      fields_dict['public_holiday'] = null

      this.fetchSaveItemField({
        itemId: this.localItem.id,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'CalendarDatePublicHolidayDTO', from_consumer: 'CalendarDatePublicHolidayDTO'}
      })
      this.dialog = false
    },
  },

  mounted() {
    // console.log('mounted', this.item)
    if (this.item != null)
      this.localItem = this.item
  },

  data() {
    return {
      dialog: false,
      itemSaved: null,
      form: false,
      localItem: {
        id: null,
        dt: null,
        public_holiday: null,
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
      dto_model: 'CalendarDatePublicHolidayDTO',
    }
  }
}

</script>


<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
}

.no-spin input::-webkit-outer-spin-button,
.no-spin input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>